import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import classnames from 'classnames';
import * as React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 2,
      minHeight: 30,
      height: 30,
      fontSize: 14,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      paddingTop: 0,
      paddingBottom: 0,
      minWidth: 0
    },
    yellow: {
      background: theme.button.yellow.background,
      color: theme.button.yellow.color,
      '&:hover': {
        background: theme.button.yellow.background,
        color: theme.button.yellow.color,
        opacity: 0.8
      }
    },
    grey: {
      background: theme.button.grey.background,
      color: theme.button.grey.color,
      'hover:&': {
        background: theme.button.grey.background,
        color: theme.button.grey.color,
        opacity: 0.8
      }
    },
    transparent: {
      background: theme.button.transparent.background,
      color: theme.button.transparent.color,
      'hover:&': {
        background: theme.button.transparent.background,
        color: theme.button.transparent.color,
        opacity: 0.8
      }
    },
    white: {
      background: '#fff',
      color: '#000',
      'hover:&': {
        background: '#fff',
        color: '#000',
        opacity: 0.8
      }
    },
    pink: {
      backgroundColor: '#ffdede',
      color: '#d0021b',
      '&:hover': {
        backgroundColor: '#ffdede',
        color: '#d0021b',
        opacity: 0.8
      }
    },
    disabledPink: {
      color: `${theme.button.yellow.color} !important`,
      opacity: 0.5
    },
    disabledYellow: {
      color: `${theme.button.yellow.color} !important`,
      opacity: 0.5
    },
    disabledTransparent: {
      color: `${theme.button.transparent.color} !important`,
      opacity: 0.5
    },
    disabledGrey: {
      color: `${theme.button.grey.color} !important`,
      opacity: 0.5
    },
    disabledWhite: {
      // color: `${theme.button.yellow.color} !important`
    },
    error: {}
  });

type btnTypes = 'yellow' | 'transparent' | 'grey' | 'red' | 'white' | 'pink';
interface IMyButtonProps extends ButtonProps {
  btnType: btnTypes;
}

function MyButton(props: IMyButtonProps & WithStyles<typeof styles>) {
  const { classes, btnType, className, ...buttonProps } = props;
  const btnClassnames = classnames(classes.root, className, {
    [classes.yellow]: btnType === 'yellow',
    [classes.grey]: btnType === 'grey',
    [classes.transparent]: btnType === 'transparent',
    [classes.white]: btnType === 'white',
    [classes.pink]: btnType === 'pink'
  });

  // render
  return (
    <Button
      {...buttonProps}
      className={btnClassnames}
      classes={{
        disabled: classnames({
          [classes.disabledYellow]: btnType === 'yellow',
          [classes.disabledGrey]: btnType === 'grey',
          [classes.disabledTransparent]: btnType === 'transparent',
          [classes.disabledWhite]: btnType === 'white',
          [classes.disabledPink]: btnType === 'pink'
        })
      }}
    >
      {props.children}
    </Button>
  );
}

export default withStyles(styles)(MyButton);
